import { LitElement, html, css } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import './nv-rail';
import './nv-topbar';
import './nv-sidebar';
import './nv-scene';
import './nv-inspector';
import './nv-console';
import './nv-app-store';
import './nv-toast';
import './nv-modal';
import './nv-palette';
import './nv-debug-hud';
import './nv-settings-drawer';
import './nv-onboarding';
import './nv-ghost-murmur';
import './nv-help';
import './nv-home';
import './nv-rssi-monitor';

export type View = 'home' | 'scene' | 'apps' | 'inspector' | 'witness' | 'ghost-murmur' | 'rssi-monitor';

@customElement('nv-app')
export class NvApp extends LitElement {
  @state() private view: View = 'rssi-monitor';

  static styles = css`
    :host { display: block; height: 100vh; width: 100vw; background: var(--bg-0); }
    .app {
      display: grid;
      grid-template-columns: 56px 280px 1fr 340px;
      grid-template-rows: 48px 1fr 220px;
      grid-template-areas: 'rail topbar topbar topbar' 'rail sidebar main inspector' 'rail sidebar console inspector';
      height: 100vh; width: 100vw;
    }
    .app.simple {
      grid-template-columns: 56px 1fr;
      grid-template-rows: 48px 1fr;
      grid-template-areas: 'rail topbar' 'rail main';
    }
    .app.simple nv-sidebar, .app.simple nv-inspector, .app.simple nv-console { display: none; }
    nv-rail { grid-area: rail; }
    nv-topbar { grid-area: topbar; }
    nv-sidebar { grid-area: sidebar; }
    .main { grid-area: main; min-width: 0; min-height: 0; position: relative; overflow: hidden; }
    nv-inspector { grid-area: inspector; }
    nv-console { grid-area: console; min-height: 0; }
    @media (max-width: 860px) {
      .app { grid-template-columns: 1fr; grid-template-rows: 52px 1fr 200px; grid-template-areas: 'topbar' 'main' 'console'; }
      nv-rail, nv-sidebar, nv-inspector { display: none; }
    }
  `;

  override render() {
    const isSimple = this.view === 'home' || this.view === 'rssi-monitor';
    return html`
      <div class="app ${isSimple ? 'simple' : ''}">
        <nv-rail .view=${this.view} @navigate=${(e: CustomEvent<View>) => (this.view = e.detail)}></nv-rail>
        <nv-topbar></nv-topbar>
        <nv-sidebar></nv-sidebar>
        <main class="main" id="main-content" tabindex="-1" role="main" aria-label="Main view">
          ${this.view === 'home' ? html`<nv-home></nv-home>`
            : this.view === 'apps' ? html`<nv-app-store></nv-app-store>`
            : this.view === 'ghost-murmur' ? html`<nv-ghost-murmur></nv-ghost-murmur>`
            : this.view === 'rssi-monitor' ? html`<nv-rssi-monitor></nv-rssi-monitor>`
            : this.view === 'inspector' ? html`<nv-inspector expanded .pinTab=${'signal'}></nv-inspector>`
            : this.view === 'witness' ? html`<nv-inspector expanded .pinTab=${'witness'}></nv-inspector>`
            : html`<nv-scene></nv-scene>`}
        </main>
        <nv-inspector .pinTab=${this.view === 'inspector' ? 'signal' : this.view === 'witness' ? 'witness' : null}></nv-inspector>
        <nv-console></nv-console>
      </div>
      <nv-toast></nv-toast>
      <nv-modal></nv-modal>
      <nv-palette></nv-palette>
      <nv-debug-hud></nv-debug-hud>
      <nv-settings-drawer></nv-settings-drawer>
      <nv-onboarding></nv-onboarding>
      <nv-help></nv-help>
    `;
  }
}
